import Banner from "../components/Banner";
import InfoHighlights from "../components/InfoHighlights";
import MeditationCenters from "../components/MeditationCenters";
import ImpactStats from "../components/ImpactStats";
import OriginSection from "../components/OriginSection";
import CorporateMeditationForm from "../components/CorporateMeditationForm";
import DonationCallout from "../components/DonationCallout";
import ChakraOverlay from "../components/ChakraOverlay";

const Home = () => {
  const handleScroll = () => {
    const section = document.getElementById("intro-section");
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="overflow-x-hidden">
      {/* Hero Banner */}
      <Banner
        image="/Banner-SN.png"
        heading="Welcome to ShreeNirmala"
        subheading="Awaken your spirit through Meditation and Chakra balance"
        onLearnMore={handleScroll}
      />

      {/* Stats */}
      <ImpactStats />

    
      

      {/* Highlights about Sahaja Yoga */}
      <InfoHighlights />

      {/* Chakra Overlay System */}
     <ChakraOverlay />

      {/* History and Founder */}
      <OriginSection />

      {/* Center Info */}
      <MeditationCenters />

      {/* Corporate Engagement */}
      <CorporateMeditationForm />

      {/* Donation Support */}
      <DonationCallout />
    </section>
  );
};

export default Home;
